/* eslint-disable import/prefer-default-export */

/**
 * Helper function to use in `Array.filter` chains to get correct type inference
 */
export const filterNullOrUndefined = <T>(item: T | null | undefined | boolean): item is T => {
  if (!!item && typeof item !== 'boolean') return true;
  return false;
};
